module.exports = __webpack_public_path__ + "img/blackpanther.93b72246.svg";